export const environment = {
  production: true,
  buildId: '3484775595022311',
  configFile: 'config.json',
};
